import React, { useState } from 'react';
import './Partners.css';
import PartnerModal from './PartnerModal';

const PARTNER_CARDS = [
  {
    key: 'starex',
    logo: '/heroes/starx.webp',
    alt: 'Starex University',
    name: 'Starex University',
    location: 'Gurugram',
  },
];

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const Partners = ({ onApplyNow }) => {
  const [openModal, setOpenModal] = useState(null);

  return (
    <section className="partners section">
      <p className="partners-label">Our Campus Partners</p>
      <div className="partners-track">
        {PARTNER_CARDS.map(({ key, logo, alt, name, location }) => (
          <div
            key={key}
            className="partner-card"
            onClick={() => setOpenModal(key)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && setOpenModal(key)}
          >
            <img src={logo} alt={alt} className="partner-logo" />
            <div className="partner-info">
              <span className="partner-name">{name}</span>
              <span className="partner-location">{location}</span>
            </div>
            <span className="partner-cta">
              <span className="partner-cta-text">View Details</span>
              <span className="partner-cta-icon"><ArrowIcon /></span>
            </span>
          </div>
        ))}
      </div>
      {openModal && (
        <PartnerModal
          partnerKey={openModal}
          onClose={() => setOpenModal(null)}
          onApplyNow={onApplyNow}
        />
      )}
    </section>
  );
};

export default Partners;
